import { render, staticRenderFns } from "./assignModal.vue?vue&type=template&id=dd141bce&scoped=true"
import script from "./assignModal.vue?vue&type=script&lang=js"
export * from "./assignModal.vue?vue&type=script&lang=js"
import style0 from "./assignModal.vue?vue&type=style&index=0&id=dd141bce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd141bce",
  null
  
)

export default component.exports